export const setLongDateRange = (date = null, rangeSettings = {}) => {
  const { month, day } = rangeSettings
  const currentDate = date ? new Date(date) : new Date()
  const offsetTimeZoneHours = currentDate.getTimezoneOffset() / 60 // seems to return an extra hour in the winter
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth()
  const currentDayDate = currentDate.getDate()
  const monthStartDate = new Date(
    currentYear,
    month !== undefined ? currentMonth - month + 1 : currentMonth,
    day !== undefined ? currentDayDate - day + 1 : 1,
    -offsetTimeZoneHours,
    0,
    0
  )
  const monthEndDate = new Date(
    currentYear,
    currentMonth + 1,
    0,
    23 - offsetTimeZoneHours,
    59,
    59,
    59
  )
  return {
    monthStartDate: monthStartDate,
    monthEndDate: monthEndDate,
    offsetTimeZoneHours: offsetTimeZoneHours
  }
}
